import Image from "next/image";
import styled from "styled-components";

import { colourScheme } from "utils/styling/colours";

interface GalleryItemWrapperProps {
    $isSelected: boolean; // Define the type of the prop
}

export const LazyLoadImage = styled(Image)`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
    cursor: pointer;

    &:hover {
        transform: scale(1.05);
    }
`;

export const ImageWrapper = styled.div`
    background-color: ${colourScheme.primaryLight};
    border-radius: 0.5rem;
    overflow: hidden;
    position: relative;
`;

export const GalleryItemWrapper = styled.div<GalleryItemWrapperProps>`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    margin-bottom: 1rem;

    background-color: ${colourScheme.primaryLight};
    border-radius: 0.5rem; /* rounded-lg */
    overflow: hidden;
    position: relative;

    /* Conditionally apply styles based on isSelected */
    ${({ $isSelected }) =>
        $isSelected
            ? `
        box-shadow: 0 0 0 2px red; /* ring-2 */
        outline: 2px solid red; /* outline outline-red-500 */
      `
            : ""}
`;

export const ImageContainer = styled.div`
    position: relative;
    width: 100%;
    overflow: hidden;
`;

export const SelectButton = styled.button<{ $isSelected: boolean }>`
    width: 2rem; /* Tailwind: h-8 w-8 */
    height: 2rem;
    background-color: ${(props) =>
        props.$isSelected
            ? "var(--color-primary)"
            : "rgba(255, 255, 255, 0.8)"};
    color: ${(props) =>
        props.$isSelected ? colourScheme.error : colourScheme.primary};
    border: none;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:focus {
        outline: none;
    }
`;

export const SelectButtonWrapper = styled.div`
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    transition: opacity 0.3s;

    ${ImageWrapper}:hover & {
        opacity: 1;
    }
`;
